<div class="inner-container">
  @if (isloading) {
    <mat-progress-bar mode="indeterminate" value="80">
    </mat-progress-bar>
  }
  @for (usage of allUsage; track usage) {
    <app-usage-card [solutionUsage]=usage />
  }
</div>